// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__w2Kr4","inner":"Footer_inner__2lzyB"};